
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Asynchronously posts a job ad for an existing position opening.`}</p>
    <p>{`If the position opening already contains 25 position profiles this will fail with a `}<inlineCode parentName="p">{`BAD_USER_INPUT`}</inlineCode>{` error.`}</p>
    <p>{`Once the job ad has been posted a `}<inlineCode parentName="p">{`PositionProfilePosted`}</inlineCode>{` event will be emitted.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;